// Search parameters of the session pages, apart from the pages: the route files import only this
// (a route's search validation stays in the initial bundle; its component is loaded on demand).
import { z } from 'zod';

/** Why a sign-in did not complete (set by the BFF, apps/api LoginService). */
export const SignedOutSearchSchema = z.object({
  reason: z
    .enum(['login_failed', 'cancelled', 'email_not_verified', 'account_disabled'])
    .optional()
    .catch(undefined),
});
export type SignedOutReason = NonNullable<z.infer<typeof SignedOutSearchSchema>['reason']>;
